"use strict";

exports.__esModule = true;
exports.default = void 0;
var defaultOptions = {
  respectDNT: false,
  productionOnly: true
};
var _default = defaultOptions;
exports.default = _default;